<template>
	<div>
		<div class="row abiuts" >
			<div class="col-8 offset-2">
				<div class="img"><img style="width: 100%;" class="img-fluid" src="../../../static/images/about_list2.png" /></div>
				<div class="row abiuts_li">
					<div class="col-12 col-sm-6 mt-3">
						<span>品牌定位：</span>
						<span>新一线年轻时尚品牌</span></div>
					<div class="col-12  col-sm-6 mt-3">
						<span>广告语：</span>
						<span>金利高 为成功而来</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>品牌口号：</span>
						<span>金利高  金利高  勇创新高！</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>核心价值观：</span>
						<span>年轻  敢想敢干，勇闯天下</span>
						<span>活力  充满激情，积极创新</span>
						<span>时尚  健康时尚,引领生活	</span>
						<span>分享  主动分享，共生共赢</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>品牌理念：</span>
						<span>1、经营理念：分享共享   成人达己</span>
						<span>2、服务理念：销售有起点  服务无终点</span>
						<span>3、人才理念：包容个性   本心本事</span>
						<span>4、产品理念：匠心质造   臻于至善</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>品牌愿景：</span>
						<span>1、新一线时尚品牌</span>
						<span>2、有建筑的地方 就有金利高陶瓷</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>品牌精神：</span>
						<span> 求精务实，创新致胜 </span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>团队文化：</span>
						<span>锲而不舍 舍我其谁</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>工作作风：</span>
						<span>快速行动、不找借口、全力以赴、坚决达成</span>
					</div>
					<div class="col-12  col-sm-6 mt-3">
						<span>品牌使命：</span>
						<span>打造中国时尚家居新一线中高端品牌</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {}
	}
</script>

<style scoped lang="less">
	@w: 19.2vw;
	.img {
		margin: 20/@w 0;
	}
   .abiuts{
     font-size: 16/@w;
     color: #8A8A8A;
     span{
     	display: block;
     	&:nth-child(1){
     		color: #A38061;
     		font-weight: bold;
     	}
     }
   }   
   .abiuts_li{
    padding: 0 40/@w;
    box-sizing: border-box;
    margin-bottom: 30/@w;
   }
</style>


// WEBPACK FOOTER //
// src/components/aboutList2/index.vue